export default __webpack_public_path__ + "static/media/edit-star.4f346e7a.svg";